import { render, staticRenderFns } from "./DealTime.vue?vue&type=template&id=d5cdf3fa&scoped=true&"
import script from "./DealTime.vue?vue&type=script&lang=js&"
export * from "./DealTime.vue?vue&type=script&lang=js&"
import style0 from "./DealTime.vue?vue&type=style&index=0&id=d5cdf3fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5cdf3fa",
  null
  
)

component.options.__file = "DealTime.vue"
export default component.exports